module.exports = __webpack_public_path__ + "img/яблоки и желтый бокал 60х80.5a7c8933.jpg";